import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate } from 'react-router-dom';

import withErrorBoundary from 'src/hocs/withErrorBoundary';

const AuthCheckView = () => {
  const { authState } = useOktaAuth();

  if (authState.isAuthenticated) {
    return <Navigate to="/app/home" />;
  }
  return <Navigate to="/sso" />;
};

export default withErrorBoundary(AuthCheckView);
